export interface HomeHeroButtons {
  label: string;
  icon: string;
  action: ButtonAction;
  isActive: boolean;
}

export interface HomeBalanceHero {
  accountBalance: string;
  buttons: HomeHeroButtons[];
}

export enum ButtonAction {
  Invest = 'go-to-invest',
  Deposit = 'go-to-deposit',
  Transfer = 'go-to-transfer'
}
